import {BaseDao} from "./BaseDao";
import {ApiHelper} from "../apiHelper";
import {ConstantMan} from "../constantMan";

export class MatchingBackfillDao extends BaseDao {

    constructor(apiHelper: ApiHelper) {
        super(ConstantMan.API.RESOURCE.MATCHING_BACKFILL, apiHelper);
    }
}